import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';

// A reusable input field component for our form
const MeasurementInput = ({ label, value, onChange, unit = 'cm' }) => (
  <div className="mb-4">
    <label className="block text-sm font-medium text-gray-500">{label}</label>
    <div className="mt-1 relative rounded-md shadow-sm">
      <input
        type="number"
        step="0.1"
        value={value}
        onChange={onChange}
        className="w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
      />
      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <span className="text-gray-500 sm:text-sm">{unit}</span>
      </div>
    </div>
  </div>
);

// The Main Modal Component
function MadeToMeasureModal({ isOpen, onClose, onConfirm }) {
  // State to hold all measurement values inside the modal
  const [measurements, setMeasurements] = useState({
    dressLength: '',
    chestAround: '',
    waist: '',
    hem: '',
    hip: '',
  });

  const handleInputChange = (field) => (event) => {
    setMeasurements(prev => ({ ...prev, [field]: event.target.value }));
  };

  const handleConfirm = () => {
    // Optional: Add validation to ensure all fields are filled
    for (const key in measurements) {
      if (!measurements[key]) {
        alert(`Please fill out the ${key.replace(/([A-Z])/g, ' $1').toLowerCase()} field.`);
        return;
      }
    }
    onConfirm(measurements);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-3xl rounded-xl bg-gray-50 p-6">
          <Dialog.Title className="text-2xl font-bold text-gray-800 border-b pb-4">
            Measurements
          </Dialog.Title>
          
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            
            {/* --- Column 1: Left Inputs --- */}
            <div className="col-span-1">
            <MeasurementInput label="Chest" value={measurements.chestAround} onChange={handleInputChange('chestAround')} />
            <MeasurementInput label="Waist" value={measurements.waist} onChange={handleInputChange('waist')} />
            <MeasurementInput label="Hip" value={measurements.hip} onChange={handleInputChange('hip')} />
           
             
            </div>

            {/* --- Column 2: Center Diagram --- */}
            <div className="col-span-1 flex justify-center">
              <img src="/images/body-diagram.png" alt="Body measurement diagram" className="max-w-full h-auto" />
            </div>

            {/* --- Column 3: Right Inputs --- */}
            <div className="col-span-1">
            <MeasurementInput label="Dress Length" value={measurements.dressLength} onChange={handleInputChange('dressLength')} />
              <MeasurementInput label="Hem Width" value={measurements.hem} onChange={handleInputChange('hem')} />
             
            </div>

          </div>

          <div className="mt-8 pt-6 border-t flex justify-end gap-4">
            <button
              onClick={onClose}
              className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="px-5 py-2 text-sm font-medium text-white bg-pink-600 rounded-md hover:bg-pink-700"
            >
              Confirm Measurements
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default MadeToMeasureModal;